import { ProductHelpers } from '@/helpers/ProductHelpers.js';

export const state = () => ({
  currentProduct: null,
});

export const mutations = {
  setProduct(state, { product }) {
    state.currentProduct = product;
  },

  init(state) {
    state.currentProduct = null;
  },
};

export const actions = {
  async fetchProduct({ commit, dispatch, state }, { permalink, currencyIsoCode, token }) {
    // Ensure visitor info (and IP) is loaded
    try {
      await dispatch('shop/localisation/fetchVisitor', null, { root: true });
    } catch (e) {
      console.warn('Failed to fetch visitor info for product tracking', e);
    }

    const productHelpers = new ProductHelpers(
      this.$http,
      this,
      this.$i18n.locale
    );

    try {
      const response = await productHelpers.getProductV2({
        permalink,
        languageIsoCode: this.$i18n.locale,
        currencyIsoCode,
        token,
        track: 1,
      });
      const product = response.data;

      if (product.Active === 1 || (token && product.Active === 0)) {
        commit('setProduct', { product });
      } else {
        // You may want to handle other status codes differently
        throw new Error('Product not found');
      }
      return response;
    } catch (error) {
      throw new Error(`Error fetching product: ${error.message}`);
    }
  },
};
